import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const MainWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SkeletonHeading = styled.div`
  width: 30%;
  height: ${toRem(24)};
  border-radius: 8px;
  background: ${baseVariables.color['neutral20']};
  margin-bottom: ${toRem(32)};
  margin-top: ${toRem(32)};
  @media (max-width: 1023px) {
    width: 60%;
    margin-bottom: ${toRem(24)};
    margin-top: ${toRem(24)};
  }

  @media (max-width: 767px) {
    width: 80%;
  }
`;

export const SkeletonWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: 520px 1fr;
  gap: ${toRem(48)};
  align-items: center;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    gap: ${toRem(32)};
  }
`;

export const SkeletonImage = styled.div`
  width: 100%;
  height: 520px;
  border-radius: ${toRem(12)};
  background: ${baseVariables.color['neutral20']};

  @media (max-width: 1023px) {
    height: ${toRem(420)};
  }

  @media (max-width: 767px) {
    height: ${toRem(280)};
  }
`;

export const SkeletonContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};
  max-width: ${toRem(560)};

  @media (max-width: 1023px) {
    max-width: 100%;
    align-items: center;
    text-align: center;
  }
`;

export const SkeletonLine = styled.div<{ width: string }>`
  height: ${toRem(16)};
  width: ${({ width }) => width};
  border-radius: ${toRem(8)};
  background: ${baseVariables.color['neutral20']};

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const SkeletonButtonRow = styled.div`
  display: flex;
  gap: ${toRem(16)};
  margin-top: 24px;

  @media (max-width: 767px) {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
`;

export const SkeletonButton = styled.div`
  width: ${toRem(140)};
  height: ${toRem(40)};
  border-radius: ${toRem(20)};
  background: ${baseVariables.color['neutral20']};

  @media (max-width: 767px) {
    width: 100%;
    max-width: ${toRem(220)};
  }
`;

export const SkeletonDots = styled.div`
  display: flex;
  gap: ${toRem(8)};
  justify-content: center;
  margin: 32px 0;
`;

export const Dot = styled.div`
  width: ${toRem(8)};
  height: ${toRem(8)};
  border-radius: 50%;
  background: ${baseVariables.color['neutral20']};
`;
